import { type PaginationParams } from '@webapp/core/providers/Pagination/pagination.types'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type CardStatusEnum } from '@webapp/modules/spending-cards/entities/enums/CardStatusEnum'
import { type IssuingProviderNameEnum } from '@webapp/modules/spending-cards/entities/enums/IssuingProviderNameEnum'
import { SpendingCardKeys } from '@webapp/modules/spending-cards/entities/enums/SpendingCardKeysEnum'

export const cardQueryConfig = {
  adminCard: (externalId: string) => ({
    queryKey: buildQueryKey([...SpendingCardKeys.GET_CARD_ADMIN, externalId]),
  }),
  detailedCard: (externalId: string) => ({
    queryKey: buildQueryKey([...SpendingCardKeys.GET_CARD_DETAILS, externalId]),
  }),
  myPhysicalCard: () => ({
    queryKey: buildQueryKey([...SpendingCardKeys.GET_MY_PHYSICAL_CARD]),
  }),
  requestableCards: (paginationParams: PaginationParams) => ({
    queryKey: buildQueryKey([
      ...SpendingCardKeys.GET_REQUESTABLE_CARDS,
      paginationParams,
    ]),
  }),
  cardCountsAdmin: (provider?: IssuingProviderNameEnum, queryParams?: {}) => ({
    // provider may be undefined mid-array; buildQueryKey would truncate it and
    // drop queryParams, so keep the plain array to preserve the exact key.
    queryKey: [
      ...SpendingCardKeys.GET_CARD_COUNTS_ADMIN,
      provider,
      queryParams,
    ],
  }),
  cardsAdmin: ({
    status,
    requireActivation,
    paginationParams,
    queryParams,
  }: {
    status: CardStatusEnum
    requireActivation?: boolean
    paginationParams: PaginationParams
    queryParams: {}
  }) => ({
    // requireActivation may be undefined mid-array; keep the plain array so
    // buildQueryKey does not truncate the trailing params.
    queryKey: [
      ...SpendingCardKeys.GET_CARDS_ADMIN,
      status,
      requireActivation,
      paginationParams,
      queryParams,
    ],
  }),
  cardPin: (externalId: string, scaToken?: string) => ({
    // scaToken may be undefined; keep the plain array so the key shape matches.
    queryKey: [...SpendingCardKeys.GET_CARD_PIN, externalId, scaToken],
  }),
  virtualCardPaymentDetails: (externalId: string, scaToken?: string) => ({
    // scaToken may be undefined; keep the plain array so the key shape matches.
    queryKey: [
      ...SpendingCardKeys.GET_CARD_PAYMENT_DETAILS,
      externalId,
      scaToken,
    ],
  }),
}
